import React from 'react';

const MiniMaxAI = () => (
  <article className="news-article-body">
    <p className="news-lead">
      MiniMax isn't the most talked-about Chinese AI company, but it might be the most
      quietly impressive one. Since its founding in 2021, it's built a multimodal AI platform
      used by over 100 million people - mostly through its Hailuo AI video tool and the
      Talkie AI companion app. In February 2025, it released its flagship model, M2.7, openly
      on Hugging Face. No one made a huge fuss about it. But the numbers were hard to ignore.
    </p>

    <h2>What makes MiniMax different</h2>
    <p>
      MiniMax was founded by Yan Junjie, a former SenseTime researcher. The company's
      unusual from the start - it went after real consumers rather than enterprise contracts,
      built hit apps like Hailuo (short AI-generated videos) and Talkie (AI companion
      characters), and by late 2024 was valued at $2.5 billion with over 40 million daily
      active users.
    </p>
    <p>
      That consumer foundation gave it something most AI labs lack: a constant stream of
      real-world feedback from actual users, not just benchmark evaluations.
    </p>

    <h2>MiniMax-Text-01 and M2.7</h2>
    <p>
      In late January 2025, MiniMax released <strong>MiniMax-Text-01</strong> - at the time,
      one of the longest-context models publicly available, capable of processing up to
      1 million tokens (roughly 750,000 words) in a single session. For context, that's
      enough to fit multiple novels or an entire codebase in one prompt.
    </p>
    <p>
      Then came <strong>M2.7</strong>, released in February 2025 with weights available on
      Hugging Face. It's a 456-billion parameter mixture-of-experts model - meaning it
      activates only the parts it needs for each task, which keeps it fast and efficient.
      Benchmarks placed it close to GPT-4o and Claude 3.5 Sonnet on reasoning tasks,
      while being cheaper to run.
    </p>

    <h2>The Hailuo video tool</h2>
    <p>
      MiniMax's most visible consumer product is <strong>Hailuo AI</strong>, a text-to-video
      generator that produces short, high-quality clips. It grew to tens of millions of
      users in 2024, competing directly with Sora (OpenAI) and Kling (Kuaishou). The
      video model runs on the same infrastructure as MiniMax's language models,
      demonstrating genuine multimodal capability rather than stitched-together tools.
    </p>

    <h2>Why it matters beyond China</h2>
    <p>
      MiniMax's decision to release M2.7 weights openly puts serious open-source competition
      alongside Qwen and Llama. For developers, it means access to a large-scale efficient
      model with permissive licensing. For the wider industry, it signals that Chinese
      companies are comfortable sharing research - at least when it builds developer
      ecosystems and global brand recognition.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Consumer apps aren't just a side business for MiniMax - they're the whole strategy.
        By building products people actually use every day, MiniMax gets real feedback,
        real revenue, and a real reason to push model quality forward. It's a different
        model than the pure research lab approach, and it seems to be working.
      </p>
    </div>
  </article>
);

export default MiniMaxAI;
